import { ServiceConfig } from "./types";

export const SERVICES_CONFIG: Record<string, ServiceConfig> = {
  youtube: {
    embedUrl: "https://www.youtube-nocookie.com/embed/{data-id}",
    thumbnailUrl: "https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg",
    iframe: {
      allow:
        "accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;",
    },
    cookie: {
      name: "cc_youtube",
    },
    languages: {
      ja: {
        notice:
          'このコンテンツはYouTubeによってホストされています。表示することで、YouTubeの<a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">利用規約</a>に同意することになります。',
        loadBtn: "動画を読み込む",
        loadAllBtn: "今後表示する",
      },
    },
  },
  spotify: {
    embedUrl: "https://open.spotify.com/embed/{data-id}",
    iframe: {
      allow: "encrypted-media; picture-in-picture; fullscreen;",
    },
    cookie: {
      name: "cc_spotify",
    },
    languages: {
      ja: {
        notice:
          'このコンテンツはSpotifyによってホストされています。表示することで、Spotifyの<a rel="noreferrer noopener" href="https://www.spotify.com/legal/end-user-agreement/" target="_blank">利用規約</a>に同意することになります。',
        loadBtn: "コンテンツを読み込む",
        loadAllBtn: "今後表示する",
      },
    },
  },
  gcal: {
    embedUrl: "{data-id}",
    iframe: {
      allow: "fullscreen;",
    },
    cookie: {
      name: "cc_gcal",
    },
    languages: {
      ja: {
        notice:
          'このコンテンツはGoogleによってホストされています。表示することで、Googleの<a rel="noreferrer noopener" href="https://policies.google.com/terms" target="_blank">利用規約</a>に同意することになります。',
        loadBtn: "カレンダーを読み込む",
        loadAllBtn: "今後表示する",
      },
    },
  },
  gmaps: {
    embedUrl: "{data-id}",
    iframe: {
      allow: "fullscreen;",
    },
    cookie: {
      name: "cc_gmaps",
    },
    languages: {
      ja: {
        notice:
          'このコンテンツはGoogleマップによってホストされています。表示することで、Googleマップの<a rel="noreferrer noopener" href="https://www.google.com/intl/ja/help/terms_maps/" target="_blank">利用規約</a>に同意することになります。',
        loadBtn: "地図を読み込む",
        loadAllBtn: "今後表示する",
      },
    },
  },
};
